import './page-divider.css';

const PageDivider = () => (
  <div className="container-fluid page-divider mg-top-10 mg-top-20"/>
);

export default PageDivider;
